import {createContext, useContext} from "react";
import {Brand} from "types/brand";

export const BrandsContext = createContext<Brand[] | null>(null);

export const useBrands = (): Brand[] => {
  const context = useContext(BrandsContext);
  if (!context) {
    throw new Error("useBrands must be used within a BrandsProvider");
  }
  return context;
};
